<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">{{collection | capitalise | pluralise}}</b-link> / {{item ? item.name : ''}}</span>
        <b-button v-if="profile.role === 'admin'" size="sm" variant="primary float-right" :to="{name: `${collection}_edit`}">Edit</b-button>
        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fsequence~2F${$route.params.id}`" target="_blank"><i class="fas fa-database"></i></b-button>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <b-alert :show="item.status === 'paused'" variant='warning'>
          This sequence is paused, no emails will be sent.
        </b-alert>

        <b-card-group deck>
          <b-card class='mb-2 p-2 bg-primary-4 stat' title="Total">
            <h3>{{item.total}}</h3>
          </b-card>

          <b-card class='mb-2 p-2 bg-primary-5 stat' title="Started">
            <h2>{{started}}%</h2>
          </b-card>

          <b-card class='mb-2 p-2 bg-primary-1 stat' title="Finished">
            <h2>{{bounced_rate}}%</h2>
          </b-card>

          <b-card class='mb-2 p-2 bg-primary-2 stat' title="Replied">
            <h2>{{replied_rate}}%</h2>
          </b-card>
        </b-card-group>

        <h4>Sequence</h4>
        <b-button v-b-toggle.collapse-1 class='mb-2'>View sequence</b-button>
        <b-collapse id="collapse-1" class="mt-2">
          <b-card bg-variant='light'>
            <EmailSequence :create="false" :sequence="item"  :profile="profile" :steps="item.steps" :from_email="item.sender ? item.sender.email : ''"  style='max-width: 720px;'/>
          </b-card>
        </b-collapse>

        <p class="muted"><small>Created {{item.created | datetime}}<br>Updated {{item.updated | datetime}}</small></p>
      </div>
    </b-card>

    <router-view :profile="profile" :user="user" :sequence="item" v-if="item && item.name"/>
  </b-container>
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import EmailSequence from '@/components/EmailSequence'

export default {
  metaInfo: {title: 'Sequence'},
  props: ['profile', 'user'],
  mixins: [ItemMixin],
  components: {EmailSequence},
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id),
    }
  },
  data() {
    return {
      collection: 'sequence'
    }
  },
  computed: {
    started() {
      if (!this.item.total) {return 0}
      return ((this.item.started || 0) / this.item.total * 100).toFixed(1)
    },
    bounced_rate() {
      if (!this.item.started) {return 0}
      return ((this.item.bounced || 0) / this.item.started * 100).toFixed(1)
    },
    finished_rate() {
      if (!this.item.started) {return 0}
      return ((this.item.finished || 0) / this.item.started * 100).toFixed(1)
    },
    replied_rate() {
      if (!this.item.started) {return 0}
      return ((this.item.replied || 0) / this.item.started * 100).toFixed(1)
    }
  }
}
</script>

<style>

</style>
